// asset
import itemIcon from "../../assets/img/yallalodo.png";

const LgSublist = ({ items }) => {
    return (
        <ul className="lg-sublist">
            {items.map((i) => {
                return i.subItems.length ? (
                    <li key={i.title} className="lg-item">
                        <div className="list-item-title">
                            <div className="list-img-text">
                                <img src={itemIcon} alt={i.title} />
                                <p> {i.title}</p>
                            </div>
                            <div className="arrow-svg"></div>
                        </div>
                        <LgSublist items={i.subItems} />
                    </li>
                ) : (
                    <li key={i.title} className="lg-item">
                        <div className="list-item-title">
                            <a href={i.link} className="list-img-text">
                                <img src={itemIcon} alt={i.title} />
                                <p> {i.title}</p>
                            </a>
                        </div>
                    </li>
                );
            })}
        </ul>
    );
};

export default LgSublist;
